import { createSlice } from '@reduxjs/toolkit';
import { TableData } from '@uikit/Tables/types';
import { companyLicensesApi } from '@store/rtk/companyLicenses';
import { beautifyDateTime } from '@src/utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type CompanyLicensesType = {
  companyLicensesTableData: TableData;
};

const { companyLicensesColumns } = TABLE_COLUMNS;

const initialState: CompanyLicensesType = {
  companyLicensesTableData: {
    columns: companyLicensesColumns,
    rows: [],
    size: 5,
  },
};

export const companyLicensesSlice = createSlice({
  name: 'companyLicenses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      companyLicensesApi.endpoints.getCompanyLicensesTableData.matchFulfilled,
      (state, { payload }) => {
        state.companyLicensesTableData = {
          ...state.companyLicensesTableData,
          rows: [
            ...payload.content.map((el, idx) => ({
              ...el,
              id: el.id ? el.id : idx,
              effectiveDate: beautifyDateTime(el?.effectiveDate),
              expirationDate: beautifyDateTime(el?.expirationDate),
            })),
          ],
          last: payload.last,
          page: payload.page,
          size: payload.size,
          totalElements: payload.totalElements,
          totalPages: payload.totalPages,
          filter: payload.filter,
          table: payload.table,
          requestTablePageChange:
            companyLicensesApi.endpoints.getCompanyLicensesTableData,
        };
      }
    );
  },
});

export const selectCompanyLicenses = (state: {
  companyLicenses: CompanyLicensesType;
}) => state.companyLicenses;
export const companyLicensesReducer = companyLicensesSlice.reducer;
